<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xoFY8p/tc-custom/9781667444420.jpg?1680370567591" alt="This image is the cover for the book Fortaleciendo Los Cimientos"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fortaleciendo Los Cimientos
      </h1>
      <p class="bookDescription body article font2">
        <p>La cuarta novela de la serie PEM. La civilización regresa a la granja y también todos los problemas asociados con ella. Jeb y Sophie tienen sentimientos encontrados sobre cómo manejar los cambios para ellos y para su hija. La familia en su conjunto está dividida. Algunos abrazan el regreso de la tecnología y la comida chatarra, otros la rechazan, mientras que otros intentan elegir opciones. Han sobrevivido a un PEM, el colapso de la civilización y un terremoto catastrófico, ¿podrán sobrevivir a esto? <br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephanie Albright, mislibrosencastellano
      </h2>
      
      <p class="authorDescription body article">Stephanie Albright creció en Amanda, Ohio. En 1986 se fue a Mississippi a pasar el verano y nunca regresó. Se graduó de la Universidad para Mujeres de Mississippi con un título en Estudios Paralegales y tiene una Maestría en Educación de <i>Western Governors University</i>. Le encanta la historia, los viajes y la comida, no necesariamente en ese orden. Las palabras siempre han sido su pasión, ya sea leyendo o escribiendo. Ahora vive en Alabama con un pequeño gallinero y un gato muy enojado, que disfruta estar afuera casi tanto como ella. Además de leer y escribir, le encanta la jardinería, aprender sobre plantas, y tomar café en el porche.<br/> Es autora de varias novelas publicadas y un cuento.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Babelcube Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8d99375e